module.exports = __webpack_public_path__ + "static/assets/132acc314440b901152ad805d8911aaf.png";